import * as React from 'react';
export const DualListSelectorContext = React.createContext({ isTree: false });
export const DualListSelectorListContext = React.createContext({});
export const DualListSelectorPaneContext = React.createContext({ isChosen: false });
//# sourceMappingURL=DualListSelectorContext.js.map